
export const maxClicksCouponFiltering = {
  campaignTypeFiltering: "CampaignType eq 'Default' or CampaignType eq 'Shopping'",
  biddingStrategyTypeFiltering: "DisplayBiddingStrategyType ne 'MaxClicks'",
};
